import request from "@/utils/request";
import qs from "qs";

// order
// export function getOrderList(params) {
//   return request.get("/api/v3/column_hybrid/douyin/order_list", { params });
//   // return request.get("/api/v3/column_hybrid/adm_order_list", { params });
// }

// 学习资料
// export function createComplain(params) {
//   return request({
//     url: `/api/v3/column_hybrid/douyin/complain_create`,
//     method: "post",
//     params,
//   });
// }

// 4. 专栏查询 对应document list
// - GET /api/v3/document/column/list?product_id=XX&keyword=XXX
// 5. 建立文档和product关联关系
// - POST /api/v3/document/relative?document_id=XXX&product_ids=1,2,3

export function createDocument(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return request.post("/api/v3/document/create", data, config);
}

export function joinDocument(id, ids) {
  return request({
    url: `/api/v3/document/relative?document_id=${id}&product_ids=${ids}`,
    method: "post",
  });
}

export function uploadDocument(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return request.post("/api/v2/server/upload_temp", data, config);
}

export function getColumnDocumentList(params) {
  return request.get("/api/v3/document/column/list", { params });
}

export function getDocumentList(params) {
  return request.get("/api/v3/document/list", { params });
}

export function setDocumentHomepage(documentId, showHomepage) {
  return request({
    url: `/api/v3/document/${documentId}/setHomepage?showHomepage=${showHomepage}`,
    method: "post",
  });
}

export function deleteDocument(documentId) {
  // return apiBase.post(`/api/v3/document/${documentId}/delete`);
  return request({
    url: `/api/v3/document/${documentId}/delete`,
    method: "post",
  });
}

// // 获取导入专栏
export function getImportColumnsList(teacherId, params) {
  return request.get(`/api/v3/column_hybrid/${teacherId}/find_list`, {
    params,
  });
}

// // 导入专栏
// export function createColumn(teacherId, params) {
//   const config = {
//     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//   };
//   return apiBase.post(`/api/v3/column_hybrid/${teacherId}/create`, qs.stringify(params), config);
// }

// // 获取专栏
export function getColumnsList(teacherId, params) {
  return request.get(`/api/v3/column_hybrid/${teacherId}/find_column_list`, {
    params,
  });
}

export function getDocumentColumns(params) {
  return request.get(`/api/v3/document/list_columns`, {
    params,
  });
}

export function unrelativeDocument(data) {
  return request({
    url: `/api/v3/document/unrelative`,
    method: "post",
    data: qs.stringify(data),
  });
}

// POST  获取下载令牌
export function createDownloadCode(documentId) {
  return request({
    url: `/api/v3/document/${documentId}/create_download_code`,
    method: "post",
  });
}

// GET 下载文件
export function downloadFile(code) {
  return request.get(`/api/v3/document/download/${code}`);
}

// 今日销量排行
export function findTodayOrderList(params) {
  return request.get(`/api/v3/column_hybrid/findTodayOrderList`, {
    params,
  });
}

// 首页数据概览
export function findHomeOverview(params) {
  return request.get(`/api/v3/column_hybrid/findHomeOverview`, {
    params,
  });
}

// 首页数据概览新版
export function togetherOvertView(params) {
  return request.get(`/api/v3/column_hybrid/togetherOvertView`, {
    params,
  });
}

export function getDoudianFee(params) {
  return request.get(`/adm/doudian/income/detail`, {
    params,
  });
}

export function getChannelFee(params) {
  return request.get(`/api/v3/column_hybrid/doudian_menu_permissions`, {
    params,
  });
}

export function getRRJFee(id, params) {
  return request.get(`/adm/user/${id}/fee_scale`, {
    params,
  });
}

// 首页数据概览新版
export function togetherOvertViewChart(params) {
  return request.get(`/api/v3/column_hybrid/togetherOvertViewChart`, {
    params,
  });
}

// 获取讲师的抖店配置
export function getDoudianConfig(params) {
  return request.get(
    `/api/v3/doudian/core/getShopIdByUserId?userId=${params.userId}`,
    {}
  );
}
